import { StepType } from '../../../entities/rates';

export const processSteps: { icon: string; type: number }[] = [
  {
    icon: 'office-building',
    type: StepType.search,
  },
  {
    icon: 'edit',
    type: StepType.form,
  },
  {
    icon: 'bank-card',
    type: StepType.payment,
  },
];

export const isSearchStep = (active: number) => processSteps[active].type === StepType.search;
export const isFormStep = (active: number) => processSteps[active].type === StepType.form;
export const isPaymentStep = (active: number) => processSteps[active].type === StepType.payment;
